// import { IpcNotificationPayload } from '@fly/desktop';
// import { buildLoginUrl } from '@fly/features/auth';
import log from 'loglevel';

import { IPlatformService } from './platform-service.interface';

export class ElectronPlatformService implements IPlatformService {
  private logoutFunction: (() => void) | null = null;

  private getElectronAPI(): NonNullable<Window['electronAPI']> {
    if (typeof window !== 'undefined' && window.electronAPI) {
      return window.electronAPI;
    }
    throw new Error('Electron API not available - running in web environment');
  }

  login(): void {}

  logout(): void {
    log.info('Electron API logout');
  }

  setLogoutFunction(logout: (redirectUri?: string) => void) {
    this.logoutFunction = logout;
  }

  async pushNotification(payload: any): Promise<void> {
    try {
      const electronAPI = this.getElectronAPI();
      await electronAPI.pushNotification(payload);
    } catch (error) {
      console.error('Electron API not available:', error);
    }
  }
}
